import React, { useEffect, useState } from "react";
import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_EMPLOYEES_LIST,
} from "../RollCallConfig/RollCallConfig";
import { Select } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const ViewEmpShifts = () => {
  const [empShiftsData, setEmpShiftsData] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found ");
    }
  }, []);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_EMPLOYEES_LIST}?superid=${superIdData}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.status) {
            setEmployees(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setEmployees([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [tokenData, superIdData]);

  const empOptions = employees.map((emp) => ({
    value: emp.regid,
    label: emp.UserName,
  }));

  const handleGetShiftDataByEmp = () => {
    if (tokenData && superIdData) {
      const fetchDeptsEmployees = async () => {
        try {
          const empResponse = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/shifts/getAssignshiftByEmp?regid=${selectedEmp}`,
            {
              method: "GET",
              headers: { Authorization: `Bearer ${tokenData}` },
            }
          );
          const empsData = await empResponse.json();
          if (empsData["status"]) {
            setEmpShiftsData(empsData["ResultData"]);
          } else {
            console.log("Failed to fetch eployees shifts:", empsData.Message);
            setEmpShiftsData([]);
          }
        } catch (error) {
          console.error("Error fetching eployees shifts:", error.message);
        }
      };
      fetchDeptsEmployees();
    } else {
      alert("need superid");
    }
  };
  const formatDate = (dateStr) => {
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(new Date(dateStr));
  };

  return (
    <div>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasRightViewEmpShifts {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightViewEmpShifts {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightViewEmpShifts {
            width: 40% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightViewEmpShifts {
            width: 20% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightViewEmpShifts {
            width:17% !important;
          }
        }
        `}
      </style>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewEmpShifts"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">View Employee Shifts</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          <form>
            <div className="content">
              <div className="row mb-3">
                <div className="col-12 col-md-5">
                  <label htmlFor="employeeSelect" className="form-label">
                    Employee
                  </label>
                  <div className="d-flex align-items-center">
                    <div
                      className="form-control p-0 border-0"
                      style={{ width: 180 }}
                    >
                      <Select
                        id="employeeSelect"
                        placeholder="Select Employee"
                        value={selectedEmp}
                        onChange={setSelectedEmp}
                        options={empOptions}
                        style={{ width: 170, height: 37 }}
                      />
                    </div>
                    <button
                      className="btn btn-primary ms-2"
                      onClick={(e) => {
                        e.preventDefault();
                        handleGetShiftDataByEmp();
                      }}
                      aria-label="Search Employee Shift"
                      style={{ height: "100%", marginRight: "30px" }}
                    >
                      <FontAwesomeIcon icon={faMagnifyingGlass} />
                    </button>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="d-flex justify-content-between">
                  <p>
                    Badge:{" "}
                    <span className="fw-semibold badge bg-primary">
                      {empShiftsData[0]?.Badge}
                    </span>
                  </p>
                  <p>
                    Department:{" "}
                    <span className="fw-semibold badge bg-info">
                      {empShiftsData[0]?.deptname}
                    </span>
                  </p>
                  <p>
                    Designation:{" "}
                    <span className="fw-semibold badge bg-secondary">
                      {empShiftsData[0]?.Designation}
                    </span>
                  </p>
                </div>
                <table className="table datanew dataTable no-footer">
                  <thead>
                    <tr>
                      <th>S.no</th>
                      <th>Shift</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {empShiftsData.length > 0 ? (
                      empShiftsData.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.Name}</td>
                          <td>{formatDate(item.StartDate)}</td>
                          <td>{formatDate(item.EndDate)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr className="text-center">
                        <td colSpan={4}>No data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ViewEmpShifts;
